import { render } from "./UserResetPasswordForm.vue?vue&type=template&id=15918c84&scoped=true&ts=true"
import script from "./UserResetPasswordForm.ts?vue&type=script&lang=ts"
export * from "./UserResetPasswordForm.ts?vue&type=script&lang=ts"

import "./UserResetPasswordForm.scss?vue&type=style&index=0&id=15918c84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15918c84"]])

export default __exports__